import { MessageState, ON_MESSAGE, REMOVE_MESSAGE } from 'core/redux/types';
import { Store } from 'utils/Store';

export const registerMessage = (payload: MessageState) => {
  const store = Store.getInstance();
  store.dispatch({
    type: ON_MESSAGE,
    payload,
  });
};

export const removeMessage = () => {
  const store = Store.getInstance();
  store.dispatch({
    type: REMOVE_MESSAGE,
  });
};
